// 메인 시안의 데스크톱 분기 기준. `tailwind.config.ts` 의 `xl` 스크린과 같은 값이며,
// 둘 중 하나만 바꾸면 JS 분기와 CSS 분기가 어긋나므로 항상 함께 고친다.
export const MAIN_XL_BREAKPOINT_PX = 1200;
export const MAIN_XL_MIN_QUERY = `(min-width: ${MAIN_XL_BREAKPOINT_PX}px)`;
export const MAIN_XL_MAX_QUERY = `(max-width: ${MAIN_XL_BREAKPOINT_PX - 1}px)`;

// 메인 히어로가 붙는 data 속성. 공용 헤더·푸터가 `main-hero:` Tailwind 변형으로
// 메인 전용 스타일을 거는 근거라, 속성명을 바꾸면 변형 정의도 함께 따라간다.
// 변형 등록은 `tailwind.config.ts` 의 plugin 에 있다.
export const MAIN_HERO_DATA_ATTR = 'data-main-hero';
